'use strict';

export default () => {
  return {
    transform: (obj) => {
      var array = [];
      if (obj) {
        Object.keys(obj).map(function(value) {
          if (obj[value]) {
            array.push(value);
          }
        });
      }

      return array;
    }
  };
};



// WEBPACK FOOTER //
// ./app/src/services/object_to_array.js